import './styles.scss'
import React, { useEffect, useState } from 'react'

import { InputControls } from 'components/common'
import { lang } from 'utils/helpers'
import { getStaticImage } from 'utils/statics'

const OptionsBrands = ({ data, selectProps, options }) => {
  const [isOpenDelegations, setIsOpenDelegations] = useState(false)
  const [allValues, setAllValues] = useState({ label: '', isChecked: false })
  const { label = '', delegations = [] } = data
  const { isMulti } = selectProps

  useEffect(() => {
    getAllValue()
  }, [selectProps.selectDelegations])

  const selectOptionBrand = (selected) => {
    if (!isMulti && selected) return

    data.isChecked = selected

    if(delegations.length === 0) {
      selectProps.onChange([], data)
    }

    const updatedDelegations = []
    for (const del of delegations) {
      if (del.isChecked !== selected){
        del.isChecked = selected
        updatedDelegations.push(del)
      }
    }

    selectProps.onChange(updatedDelegations, data)
  }

  const selectOptionDelegation = (selected, delegation) => {
    if (!isMulti && selected) {
      for (const brand of options) {
        if (brand.delegations.some(it => it.isChecked)) return
      }
    }

    if (delegation.isChecked !== selected) delegation.isChecked = selected
    selectProps.onChange([delegation], data)
  }

  const selectAll = (value) => {
    const filterBrands = []
    const filterDelegations = []

    if (value) {
      for (const opt of options) {
        if (opt.value !== 'all') {
          for (const optDelegation of opt.delegations) {
            optDelegation.isChecked = value
            filterDelegations.push(optDelegation)
          }
          opt.isChecked = value
          filterBrands.push(opt)
        }
      }
    }

    selectProps.onChange({ brands: filterBrands, delegations: filterDelegations }, data)
  }

  const selectFilter = (value) => {
    if (data.value !== 'all') selectOptionBrand(value)
    if (data.value === 'all') selectAll(value)
  }

  const getAllValue = () => {
    if (selectProps.selectDelegations === selectProps.totalDelegations) {
      setAllValues({
        label: lang('dashboard_all'),
        isChecked: true
      })
    }
    if (selectProps.selectDelegations < selectProps.totalDelegations && selectProps.selectDelegations > 0) {
      setAllValues({
        label: lang(`selector_options_${selectProps.selectDelegations === 1 ? 'one' : 'some'}`),
        isChecked: 'some'
      })
    }
    if (selectProps.selectDelegations === 0) {
      setAllValues({
        label: lang('dashboard_none'),
        isChecked: false
      })
    }
  }

  const getBrandValue = () => {
    if (delegations.every(delegation => delegation.isChecked)) return true
    if (delegations.some(delegation => delegation.isChecked)) return 'some'
    return false
  }

  return (
    <div className='containerOptions'>
      <li className='containerBrands'>
        <div className='containerOptions__label-container'>
          <button
            type='button'
            className={`
              btnOpenDelegations
              ${data.value}
              ${isOpenDelegations ? 'btnOpenDelegations--opened' : ''}
            `}
            onClick={() => {
              setIsOpenDelegations(!isOpenDelegations)
            }}
          >
            <figure>
              <img src={getStaticImage('/icons/orange-brand/icon-arrow-back-dark.svg')} alt='Arrow' />
            </figure>
          </button>
          <label className={`labelBrand text-ellipsis ${data.value}`}>
            <span className={data.value}>({delegations.length})</span>
            {data.value === 'all' ? allValues.label : label}
          </label>
        </div>
        <InputControls
          injectType='external'
          type='checkbox'
          value={data.value === 'all'
            ? allValues.isChecked
            : getBrandValue()
          }
          onChange={value => selectFilter(value) }
          color={'newPrimary'}
        />
      </li>
      <div style={{ marginTop: 8 }}>
        {isOpenDelegations && delegations.map((delegation, index) => (
          <div key={index} className='groupsDelegations__delegationsContainer'>
            <li className='containerDelegation'>
              <label className='labelDelegation text-ellipsis'>{delegation.label}</label>
              <InputControls
                injectType='external'
                className='checkOptions'
                type='checkbox'
                value={delegation.isChecked}
                onChange={value => selectOptionDelegation(value, delegation)}
                color={'newPrimary'}
              />
            </li>
          </div>
        ))}
      </div>
    </div>
  )
}

export default OptionsBrands
